export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-04.ccd4a8ed.svg";